interface PrefilledNameFields {
  name?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

// Parses a raw search string into default values for every contact name input,
// so a newly opened form is seeded no matter which type the user ends up
// picking. A company uses the whole string as `name`; a person's words split
// across first/middle/last:
//   "Cher"              -> firstName
//   "Ada Lovelace"      -> firstName, lastName
//   "John Q Public"     -> firstName, middleName, lastName
//   "Ada B C Lovelace"  -> firstName, middleName (the words between), lastName
export default function prefillNameFields(query: string | null | undefined): PrefilledNameFields {
  const name = (query || '').trim();
  if (!name) {
    return {};
  }

  const fields: PrefilledNameFields = { name };
  const parts = name.split(/\s+/);

  if (parts.length === 1) {
    fields.firstName = parts[0];
  } else if (parts.length === 2) {
    fields.firstName = parts[0];
    fields.lastName = parts[1];
  } else {
    fields.firstName = parts[0];
    fields.middleName = parts.slice(1, -1).join(' ');
    fields.lastName = parts[parts.length - 1];
  }

  return fields;
}
